import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import {
  ReportActions,
  ReportDescription,
  ReportSection,
  ReportToggle,
  ReportToggleList
} from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

// report 062
export function HighLevelTournamentAreaStartListReportForm(props: Props) {
  const requestInitial = {
    isShowBlank: true,
    isHighlightNoAge: true
  };

  return (
    <Formik
      onSubmit={values => {
        props.onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.HIGH_LEVEL_TOURNAMENT_AREA_START_LIST);
      }}
      initialValues={requestInitial}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm highLevelTournamentReportForm">
          <div className="eReportForm__content">
            <ReportDescription>
              View students from schools in your area who have been entered into this high-level tournament.
            </ReportDescription>

            <ReportSection
              number={1}
              title="Report content"
              hint="Choose which entries should be included or highlighted."
            >
              <ReportToggleList>
                <ReportToggle
                  name="isShowBlank"
                  label="Include events without participants"
                  hint="Show tournament events even when no students have been entered."
                  value={values.isShowBlank}
                  onChange={value => setFieldValue('isShowBlank', value)}
                />
                <ReportToggle
                  name="isHighlightNoAge"
                  label="Highlight students without a date of birth"
                  hint="Make incomplete date-of-birth information easy to identify in the report."
                  value={values.isHighlightNoAge}
                  onChange={value => setFieldValue('isHighlightNoAge', value)}
                />
              </ReportToggleList>
            </ReportSection>
          </div>
          <ReportActions onCancel={props.onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}

